// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionLRA_TheComp__N9sWM"};